// noinspection JSCheckFunctionSignatures

export const basicFetcher = (...args) => fetch(...args)
  .then(res => res.json())
  .catch(error => console.error(`basic-fetcher: ${error}`))
